import React from "react";
import { Card, CardTitle, CardContent, OnOffSwitch, Callout, Paragraph, Toast } from "@tv2no/ui-react";
import { updateTaxYear } from "../../../../../api/services/taxYear";

export const Control = ({ taxYear, setTaxYear }) => {
    const handleTogglePublished = (published) => {
        updateTaxYear(taxYear.year, {
            published: published
        }).then((response) => {
            setTaxYear(response);
            if(published){
                Toast.success(`Skatteåret ${taxYear.year} er publisert`);
            }else {
                Toast.error(`Skatteåret ${taxYear.year} er avpublisert`);
            }
        });
    };

    return (
        <Card>
            <CardTitle title="Kontroll" />
            <CardContent>
                <Callout color={taxYear.published ? "success" : "error"}>
                    <Paragraph>
                        Når dataimporten er fullført og skatteåret er{" "}
                        <strong>klart for offentligheten</strong> kan skatteåret publiseres.
                        Topplister og alle geografiske lister blir kun synlige på <a target="_blank" rel="noopener noreferrer" href="https://www.tv2.no/skattelisten">
                            tv2.no/skattelisten
                        </a>{" "}
                        når skatteåret er publisert her.
                    </Paragraph>
                    <OnOffSwitch value={taxYear.published} onChange={handleTogglePublished}>
                        Publisert
                    </OnOffSwitch>
                </Callout>
            </CardContent>
        </Card>
    );
};
